import {
    BASIC_COMPOSITION,
    CATEGORY_TYPE,
    HIDE_BASIC_COMPOSITION,
    ITEM_TYPE,
    SHOW_BASIC_COMPOSITION,
} from "@constants";
import PropTypes from "prop-types";
import styled from "styled-components";
import { useSnapshot } from "valtio";

import React from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import NutritionalInformationDialog from "@components/OrderTaking/Components/Dialogs/NutritionalInformation/NutritionalInformationDialog";
import { AddOrderBasicCompositionWorkflow } from "@components/OrderTaking/Components/Dialogs/WorkflowDialog/hooks";
import {
    SelectProduct,
    setIsInternalModification,
    setPreviousWorkflowStep,
    setWorkflowData,
} from "@components/OrderTaking/Store/feature";

import { kioskStore } from "@pages/Kiosk/store";

import { goToNextStep } from "./helpers";
import { InfoCloseProduct } from "./InfoCloseProduct";
import { WorkflowStepper } from "./WorkflowStepper";
import { WorkflowTitle } from "./WorkflowTitle";

const ContainerHeader = styled.div`
    display: flex;
    position: relative;
    align-items: center;
`;

function WorkflowHeader({ onClose }) {
    const dispatch = useDispatch();

    const { isPrm } = useSnapshot(kioskStore);
    const { globalcard } = useSelector((state) => state.orderSlice);
    const { workflowData } = useSelector((state) => state.workFlowDataSlice);

    const { isHeaderColorActive } = useSelector(
        (state) => state.settingSlice.compositeProductSettings,
        shallowEqual
    );

    const orderWorkflowItemSlice = useSelector(
        (state) => state.orderWorkflowItemSlice,
        shallowEqual
    );

    const currentWorkflow = workflowData[workflowData.length - 1];

    const [
        isNutritionalInformationDialogOpen,
        setIsNutritionalInformationDialogOpen,
    ] = React.useState(false);
    const handleNutritionalInformationDialogOnCloseEvent = () => {
        setIsNutritionalInformationDialogOpen(
            !isNutritionalInformationDialogOpen
        );
    };

    const options = [];
    const product = {
        ...globalcard?.items?.[
            currentWorkflow?.workflow[currentWorkflow.index]?.iuudproduct
        ],
        selectedOptions: options,
    };

    product.type = product.isRedirect ? CATEGORY_TYPE : ITEM_TYPE;
    function NextStep(workflow) {
        if (workflow.step > workflow.index) {
            goToNextStep(workflow, dispatch);
        } else {
            const copyworkflowData = JSON.parse(JSON.stringify(workflowData));
            copyworkflowData.splice(copyworkflowData.length - 1, 1);
            const copyDataworkflow = [...copyworkflowData];
            let index = copyDataworkflow.length;
            while (index > 0) {
                let workflowIndex = index - 1;
                let workflow = copyDataworkflow[workflowIndex];
                if (
                    workflow.workflow[workflow.index].NbrOfChoices <=
                    workflow.workflow[workflow.index].maxNbrOfChoices
                ) {
                    dispatch(setWorkflowData(copyworkflowData));

                    return;
                } else if (workflow.step > workflow.index) {
                    goToNextStep(workflow, dispatch);
                    return;
                } else {
                    index -= 1;
                    copyDataworkflow.splice(workflowIndex, 1);
                }
            }
            // ** ici on efface workflow
            if (copyDataworkflow.length === 0) {
                dispatch(setWorkflowData([]));
                dispatch(SelectProduct({}));
            }
        }
    }

    function NextOnClickEvent() {
        if (
            currentWorkflow.workflow[currentWorkflow.index]?.NbrOfChoices <
            currentWorkflow.workflow[currentWorkflow.index]?.minNbrOfChoices
        )
            return;
        if (currentWorkflow) {
            if (
                currentWorkflow.workflow[currentWorkflow.index].type ===
                BASIC_COMPOSITION
            ) {
                AddOrderBasicCompositionWorkflow(
                    workflowData,
                    dispatch,
                    globalcard
                );
            }
            if (currentWorkflow.step > currentWorkflow.index) {
                goToNextStep(currentWorkflow, dispatch);
            } else {
                NextStep(currentWorkflow);
            }
        }
    }

    function PreviousOnClickEvent() {
        const haveHiddenBasicComp = currentWorkflow.workflow?.some(
            (item) =>
                item.isHiddenBasicComp && !orderWorkflowItemSlice.isModification
        );

        const previousObligation = haveHiddenBasicComp
            ? HIDE_BASIC_COMPOSITION
            : SHOW_BASIC_COMPOSITION;
        if (currentWorkflow.index > previousObligation) {
            dispatch(setIsInternalModification(true));
            dispatch(setPreviousWorkflowStep());
        }
    }

    const menuItem = {
        ...product,
        price: { ...product.price, content: orderWorkflowItemSlice.item.price },
    };

    return (
        <>
            {isNutritionalInformationDialogOpen && (
                <NutritionalInformationDialog
                    open={isNutritionalInformationDialogOpen}
                    onClose={handleNutritionalInformationDialogOnCloseEvent}
                    product={menuItem}
                    isValidateButtonActive={Boolean(workflowData?.length === 0)}
                />
            )}
            <div
                className={[`${isPrm ? "h-auto" : "pt-3"} workflow-header`]}
                style={{
                    background: isHeaderColorActive
                        ? `transparent linear-gradient(180deg, #ffffff 0%, var(--global-color) 200%) 0% 0% no-repeat padding-box`
                        : "",
                }}
            >
                <ContainerHeader>
                    <WorkflowTitle
                        product={product}
                        currentWorkflow={currentWorkflow}
                    />
                    <InfoCloseProduct
                        product={product}
                        workflowData={workflowData}
                        currentWorkflow={currentWorkflow}
                        onClose={onClose}
                        handleNutritionalInformationDialogOnCloseEvent={
                            handleNutritionalInformationDialogOnCloseEvent
                        }
                    />
                </ContainerHeader>

                <WorkflowStepper
                    currentWorkflow={currentWorkflow?.workflow}
                    activestep={currentWorkflow?.index}
                    NextOnClickEvent={NextOnClickEvent}
                    PreviousOnClickEvent={PreviousOnClickEvent}
                />
            </div>
        </>
    );
}

export default WorkflowHeader;
WorkflowHeader.propTypes = {
    onClose: PropTypes.func,
};
